import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components';
import { Link, withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react';
import VisibilitySensor from 'react-visibility-sensor';

import { isClient } from '../../utils'
import { media } from '../../styles/utils'
import { container, body } from '../../styles/global';

class Annotation extends Component<Props, State> {

    state = {

    }

    onVisibilityChange = (visible) => {
        const { index, section, callback, data } = this.props;
        callback(visible, index, section, data)
    }
    
    render() {
        const { data, callback, active, index, section } = this.props;

        return (
            <VisibilitySensor
                onChange={this.onVisibilityChange}
                offset={{
                    top: isClient() ? window.innerHeight * 0.2 : 500,
                    bottom: isClient() ? window.innerHeight * 0.2 : 500,
                }}
                scrollCheck={true}
            >
                <Container
                    onClick={() => callback(true, index, section, data)}
                    active={active}
                >
                    {data.children[0].data}
                </Container>
            </VisibilitySensor>
        )
    }
}


const Container = styled.div`
    display: inline;
    cursor: pointer;
    ${body}
    background: none;
    transition: all 0.45s ease;
    position: relative;
    background: none;
    border-bottom: 3px solid #D5F1B8;

    ${props => {
        if (props.active) return css`
            background: #D5F1B8;
            border: none;
        `
    }}

    ${media.tablet`
        background: none;
        border: none;
    `}

`;

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = (state, props) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Annotation);



// WEBPACK FOOTER //
// ./client/components/Annotation/Annotation.js